
import { defaultHttpResponse, HttpResponse } from '../auth/AuthInterface';

import { defaultExpediente, ExpedienteProps } from '../recepcion/ExpedienteInterface';
import { UsuarioObservacionesProps } from './SentenciaInterface';

// Definición de defaults

export const defaultSentenciaPublica: SentenciaPublicaProps = {
    idSentenciaPublica:     0,
    idEstatus:              0,
    numeroSentencia:        '',
    juez:                   '',
    tipoSentencia:          '',
    sentidoSentencia:       '',
    contenido:              '',
    documento:              '',
    observaciones:          false,
    usuarioObservaciones:   [],
    asignadoMismoUsuario:   false,
    nombreUsuarioAsignado:  '',
    perspectivaGenero:      false,
    expediente:             defaultExpediente,
    idExpediente:           0,
}

export const defaultNuevaSentenciaPublica: NuevaSentenciaPublicaResponse = {
    ...defaultHttpResponse,
    idSentenciaPublica:     '',
}

export const defaultActualizarEstatus: ActualizarEstatusResponse = {
    ...defaultHttpResponse,
    asignadoMismoUsuario:   false,
    usuarioAsignado:        '',
}

// Creación de interfaces

export interface NuevaSentenciaPublicaParams {
    idExpediente:           number;
    idSentencia:            number;
}

export interface NuevaSentenciaPublicaResponse extends HttpResponse {
    idSentenciaPublica:     string;
}

export interface SentenciaPublicaProps {
    idSentenciaPublica:     number;
    idEstatus:              number;
    numeroSentencia:        string;
    juez:                   string;
    tipoSentencia:          string;
    sentidoSentencia:       string;
    contenido:              string;
    documento:              string;
    observaciones:          boolean;
    usuarioObservaciones:   UsuarioObservacionesProps[];
    asignadoMismoUsuario:   boolean;
    nombreUsuarioAsignado:  string;
    perspectivaGenero:      boolean;
    expediente:             ExpedienteProps;
    idExpediente:           number;
    fecha?:                 Date;
    fechaSentencia?:        Date;
}

export interface DetalleSentenciaPublicaResponse extends SentenciaPublicaProps, HttpResponse { }

export interface ActualizarSentenciaPublicaParams {
    idSentenciaPublica:     string;
    contenido:              string;
}

export interface ActualizarEstatusParams {
    idSentenciaPublica:     string;
    observaciones:          string;
    idEstatus:              number;
}

export interface ActualizarEstatusResponse extends HttpResponse {
    asignadoMismoUsuario:   boolean;
    usuarioAsignado:        string;
}